import { asText, Content } from '@prismicio/client';

import {
  Box,
  Card,
  Icon,
  Heading,
  AutoGrid,
  CardHero,
  CardTitle,
  Typography,
  CardContent,
  AutoGridLayout,
} from '@preventx/oxygen';
import { RichText } from '@preventx/prismic-services';

// Services
import { retrieveIcon } from '@/services/utils/icons';
import { applicationEnv } from '@/services/env/shared';

export type WithHowRegionProps = {
  id: string;
  slice: Content.RegionComplexSliceWithHowRegion;
};

/** **Environment Usage**
 *
 * - **Test Me** - Home Page */
export const WithHowRegion = ({ id, slice }: WithHowRegionProps) => {
  const { primary } = slice;
  const { cards, title, eyebrow } = primary;

  let autoGridLayout: AutoGridLayout | undefined = undefined;

  if (cards.length === 2) {
    autoGridLayout = '50-50';
  } else if (cards.length === 3) {
    autoGridLayout = 'thirds';
  }

  const { WebsiteUrl } = applicationEnv();

  return (
    <Box component="div" addFlow>
      <Typography component="span" addEyebrow colour="primary">
        {asText(eyebrow)}
      </Typography>

      <Heading component="h2" addHeadlineTitle>
        {asText(title)}
      </Heading>

      <AutoGrid layout={autoGridLayout} component="div">
        {cards.map((card, index) => (
          <Card
            variant="simple"
            component="article"
            key={`how-region-${id}-${index + 1}`}
          >
            <CardHero component="div">
              {card.icon !== 'None' && (
                <Box
                  component="div"
                  variant="solid"
                  addFeaturedIcon
                  colour="primary"
                >
                  <Icon icon={retrieveIcon(card.icon)} addIcon size="2x" />
                </Box>
              )}

              <CardTitle component="h3">{asText(card.title)}</CardTitle>
            </CardHero>

            <CardContent addFlow>
              <RichText
                variant="default"
                content={card.content}
                websiteUrl={WebsiteUrl}
              />
            </CardContent>
          </Card>
        ))}
      </AutoGrid>
    </Box>
  );
};
